import "./Radio.css";
import { randomUUID } from "../../axios_with_token";

export default function Radio({fldName, form, fldDef, opts}){
  opts = opts || {};
  const {onChange, ...rest} = form.register(fldName, {required: 1})
  const rdoId = `rdoid-${randomUUID()}`;

  return <div className="form-check">
    {(fldDef.src||[]).map((optDef) => {
      const [val, cap] = optDef.constructor == Array? optDef : [optDef, optDef];
      return <div key={val} className="me-3" style={{display:"inline-block"}}>
        <input
          type={opts.type || "radio"}
          value={val}
          id={`${rdoId}-${val}`}
          className="me-1"
          {...rest}
        />
        <label htmlFor={`${rdoId}-${val}`}>{cap}</label>
      </div>
    })}
  </div>;
}